module.exports = __webpack_public_path__ + "static/img/product_3.4d3f7b7a.png";